export const calculateNextIndex = (currentIndex: number, length: number) => {
  return (currentIndex + 1) % length;
};

export const calculatePreviousIndex = (
  currentIndex: number,
  length: number,
) => {
  return (currentIndex + length - 1) % length;
};
